import { useCallback, useEffect, useState } from 'react';

export function useSmartformPermissionHelper() {
  const [helperIsOn, setHelperIsOn] = useState(localStorage.getItem('smartformPermissionHelper') === 'true');

  useEffect(() => {
    const handleCustomPermission = (e: Event) => {
      if (e.type === 'custom:DebugPermissions') {
        const isOn = (e as CustomEvent).detail;
        setHelperIsOn(isOn);
        localStorage.setItem('smartformPermissionHelper', isOn ? 'true' : 'false');
      }
    };
    window.addEventListener('custom:DebugPermissions', handleCustomPermission);
    return () => {
      window.removeEventListener('custom:DebugPermissions', handleCustomPermission);
    };
  }, []);

  const setHelper = useCallback((val: boolean) => {
    const addEvent = new CustomEvent('custom:DebugPermissions', { detail: val });
    window.dispatchEvent(addEvent);
  }, []);

  return {
    helperEnabled: helperIsOn || false,
    setHelper
  };
}
